module.exports = __webpack_public_path__ + "static/img/FLORENTINE-MAPLE.1618f01.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/FLORENTINE-MAPLE.png
// module id = mUIn
// module chunks = 0